import React, { useEffect, useState } from "react";
import styles from "./styles.module.css";
import { getSentenceFromCamelCase } from "./Helpers";
import Tag from "./Tag";
import { MSelectProps } from "../../types/form";

const MultiSelect: React.FC<MSelectProps> = ({
  className,
  disabled,
  error,
  required,
  label,
  name,
  onChange,
  style,
  data,
  validationHandler,
  value,
  size,
  labelClassName,
  filter,
  filterValue,
}) => {
  const [open, setOpen] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState<string[]>([]);
  const [searchResults, setSearchResults] = useState<any[]>([]);
  const [search, setSearch] = useState("");

  const onChangeHandler = (option: string) => {
    if (selectedOptions.includes(option)) {
      const newOptions = selectedOptions.filter((item) => item !== option);
      setSelectedOptions(newOptions);
      setOpen(false);
      onChange && onChange(name, newOptions);
    } else {
      const newOptions = [...selectedOptions, option];
      setSelectedOptions(newOptions);
      onChange && onChange(name, newOptions);
      setOpen(false);
    }
  };

  const onValidationChange = () => {
    if (!validationHandler) return;
    let errorMessage = "";
    if (!selectedOptions.length && required) {
      errorMessage = `Please enter ${getSentenceFromCamelCase(name)}.`;
    }
    validationHandler(name, errorMessage);
    setOpen(false);
  };

  const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    const query = event.target.value;
    setSearch(query);

    const filteredResults = data.filter((x: any) => {
      return (
        x[filter]?.toLowerCase().includes(query.toLowerCase()) ||
        x.value?.toLowerCase().includes(query.toLowerCase())
      );
    });

    setSearchResults(filteredResults.length ? filteredResults : data);
  };

  useEffect(() => {
    if (data) {
      setSearchResults(data);
    }
  }, [data]);

  const getItemName = (item: string) => {
    const foundItem: any = data?.find((x) => x[filterValue] === item);
    return filter ? foundItem[filter] : item;
  };

  const removeHandler = (id: string) => {
    const items = selectedOptions.filter((x) => x !== id);
    setSelectedOptions(items);
  };

  return (
    <div
      className={`${styles.InputContainer} ${styles[size]}`}
      onBlur={onValidationChange}
    >
      <label htmlFor={name} className={labelClassName}>
        {label}
        {required && <span className={styles.required}>&nbsp;*</span>}
      </label>
      {error && (
        <span className={`${styles.required} ${styles.textSmall}`}>
          {error}
        </span>
      )}
      <div
        onClick={() => setOpen(!open)}
        className={`${styles.cxt} ${styles.blackBorder} ${className}`}
        style={style}
      >
        <div className={styles.cxtFlex}>
          {selectedOptions.map((option, i) => (
            <Tag
              item={getItemName(option)}
              key={i}
              remove={removeHandler}
              value={option}
            />
          ))}
        </div>
      </div>

      {open && (
        <div className={styles.dropdownContainer}>
          <div className={styles.searchContainer}>
            <input
              placeholder="Search for items..."
              value={search}
              onChange={handleSearch}
              type="search"
            />
          </div>

          <div className={styles.options}>
            {searchResults.map((item, i) => (
              <label key={i}>
                <input
                  type="checkbox"
                  checked={selectedOptions.includes(
                    filter ? item[filterValue] : item.value
                  )}
                  onChange={() =>
                    onChangeHandler(filter ? item[filterValue] : item.value)
                  }
                />
                {filter ? item[filter] : item.value}
              </label>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default MultiSelect;
